import { Fragment } from "react";
import { ChevronRight } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export type Crumb = { name: string; path: string };

/**
 * Visual breadcrumb. Pair the same `items` array with breadcrumbJsonLd()
 * in the route's head() so structured data matches what the user sees.
 */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
  // Drop any item without a real name/path so we never render an empty
  // breadcrumb crumb (a blank link/separator) in the crawled HTML.
  const crumbs = items.filter((item) => item.name?.trim() && item.path?.trim());
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((item, i) => {
          const isLast = i === crumbs.length - 1;
          // A React Fragment — not a wrapper element — so the <li> items
          // (BreadcrumbItem and the presentational BreadcrumbSeparator) are
          // direct children of the <ol>. A real wrapper element here makes
          // the list structurally invalid (ol may only contain li).
          return (
            <Fragment key={item.path}>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{item.name}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink href={item.path}>{item.name}</BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && (
                <BreadcrumbSeparator>
                  <ChevronRight className="h-3.5 w-3.5" />
                </BreadcrumbSeparator>
              )}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
